const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Ciao',
    'Ref: Page content body':
      "All'arrivo e alla partenza, ricordati di scansionare il tuo codice QR del tuo bus",
  },
};
export default labels;
